.checkbox {
    width: 105px;
    display: flex;
    justify-content: center;
}
